import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export abstract class IBetaService {
  abstract validateBetaCode(betaCode: string): Promise<{ res: any; serverError: string }>
}
